import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { SharedConstants } from "../../shared/constants/shared.constants";
import { Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { SelectedApplicationService } from "../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../app-controller.service";
import { map } from "rxjs/operators";
import { ApiPropertyAndLeaseConstants } from "../../shared/constants/api-constants/api-property-and-lease.constants";
import { ApiTownPlanningConstants } from "../../shared/constants/api-constants/api-town-planning.constants";
import { ApiBuildingPlansConstants } from "../../shared/constants/api-constants/api-building-plans.constants";
import { ApiCemeteryConstants } from "../../shared/constants/api-constants/api-cemetery.constants";
import { ApiWayleaveConstants } from "../../shared/constants/api-constants/api-wayleave.constants";
import { ApiElectricalConnectionConstants } from "../../shared/constants/api-constants/api-electrical-conection.constant";
import { ApiDemolitionManagementConstants } from "../../shared/constants/api-constants/api-demolition-management.constamt";
import { ApiInformalTradeConstants } from "../../shared/constants/api-constants/api-informal-trade.constants";
import { PropertySearchOption } from "./property-search-option";
import { ApiAdvertisingConstants } from "../../shared/constants/api-constants/api-advertising.constants";
import { ApiBusinessLicenceConstants } from "../../shared/constants/api-constants/api-business-licence.constants";
import { AppRoutingConstants } from "../../app-routing.constants";
import { ViewApplicationRoutingConstants } from "../../view-application/view-application-routing.constants";
let SearchApplicationsService = class SearchApplicationsService {
    router;
    selectedApplicationService;
    appController;
    mapLocation = new BehaviorSubject(null);
    mapLocationAsObservable = this.mapLocation.asObservable();
    isApplicationLoadedFromSearchPageSubject$ = new BehaviorSubject(false);
    isApplicationLoadedFromSearchPage = this.isApplicationLoadedFromSearchPageSubject$.asObservable();
    propertyUrl = "";
    constructor(router, selectedApplicationService, appController) {
        this.router = router;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
    }
    // build links for map locator and create application request
    addMapLocatorLinks(applications) {
        applications.forEach(app => {
            app.link = this.setMapLink(app);
            app.link2 = app.eLodgementComplete ? this.setViewApplicationLink(app) : this.setCreateApplicationLink(app);
        });
        return applications;
    }
    setViewApplicationLink(application) {
        return {
            text: SharedConstants.OPEN_APPLICATION_TEXT, address: "", clickAction: () => {
                this.appController.setSelectedModule(application.moduleId);
                this.appController.setModuleAllowResubmission();
                this.selectedApplicationService.setIncompleteJobId(application.jobId);
                this.getApplicationSelected(application);
            }
        };
    }
    setCreateApplicationLink(application) {
        return {
            text: SharedConstants.OPEN_APPLICATION_TEXT, address: "", clickAction: () => {
                this.appController.setSelectedModule(application.moduleId);
                this.appController.setModuleAllowResubmission();
                this.selectedApplicationService.setIncompleteJobId(application.jobId);
                this.isApplicationLoadedFromSearchPageSubject$.next(true);
            }
        };
    }
    getURLForModule(systemPrefix) {
        let url = "";
        switch (systemPrefix) {
            case "TP":
                url = `${ApiTownPlanningConstants.URL}/${ApiTownPlanningConstants.FUNCTION_GET_MY_AFLA_PORTAL_TOWN_PLANNING_APPLICATIONS}`;
                break;
            case "BP":
                url = `${ApiBuildingPlansConstants.URL}/${ApiBuildingPlansConstants.FUNCTION_GET_MY_AFLA_PORTAL_BUILDING_PLANS_APPLICATIONS}`;
                break;
            case "BL":
                url = `${ApiBusinessLicenceConstants.URL}/${ApiBusinessLicenceConstants.FUNCTION_GET_MY_AFLA_BUSINESS_LICENCE_APPLICATIONS}`;
                break;
            case "PL":
                url = `${ApiPropertyAndLeaseConstants.URL}/${ApiPropertyAndLeaseConstants.FUNCTION_GET_MY_AFLA_PORTAL_PROPERTY_AND_LEASE_APPLICATIONS}`;
                break;
            case "CM":
                url = `${ApiCemeteryConstants.URL}/${ApiCemeteryConstants.FUNCTION_GET_MY_AFLA_PORTAL_CEMETERY_APPLICATIONS}`;
                break;
            case "PV":
                url = "";
                break;
            case "W":
                url = `${ApiWayleaveConstants.URL}/${ApiWayleaveConstants.FUNCTION_GET_MY_AFLA_PORTAL_WAYLEAVE_APPLICATIONS}`;
                break;
            case "EC":
                url = `${ApiElectricalConnectionConstants.URL}/${ApiElectricalConnectionConstants.FUNCTION_GET_MY_AFLA_PORTAL_EC_APPLICATIONS}`;
                break;
            case "DM":
                url = `${ApiDemolitionManagementConstants.URL}/${ApiDemolitionManagementConstants.FUNCTION_GET_MY_AFLA_PORTAL_DEMOLITION_APPLICATIONS}`;
                break;
            case "A":
                url = `${ApiAdvertisingConstants.URL}/${ApiAdvertisingConstants.FUNCTION_GET_MY_AFLA_ADVERTISING_APPLICATIONS}`;
                break;
            case "IT":
                url = `${ApiInformalTradeConstants.URL}/${ApiInformalTradeConstants.FUNCTION_GET_MY_AFLA_INFORMAL_TRADING_APPLICATIONS}`;
                break;
        }
        return url;
    }
    getParamsForModule(selectedMapLocator) {
        let params;
        switch (selectedMapLocator.systemPrefix) {
            case "CM":
                params = {
                    $filter: `moduleId eq ${selectedMapLocator.moduleId} and id eq ${selectedMapLocator.applicationId}`, $expand: "family($expand=groups), deceased($expand=deceasedNames),graves"
                };
                break;
            case "W":
                params = {
                    $filter: `moduleId eq ${selectedMapLocator.moduleId} and id eq ${selectedMapLocator.applicationId}`, $expand: "applicationLines,applicationPolygons"
                };
                break;
            case "A":
                params = {
                    $filter: `moduleId eq ${selectedMapLocator.moduleId} and id eq ${selectedMapLocator.applicationId}`, $expand: "point, polygon",
                };
                break;
            default:
                params = {
                    $filter: `moduleId eq ${selectedMapLocator.moduleId} and id eq ${selectedMapLocator.applicationId}`, $expand: "properties"
                };
                break;
        }
        return params;
    }
    getApplicationSelected(application) {
        // build switch based on selected application
        this.selectedApplicationService.setSelectedApplication(application);
        this.router.navigate([AppRoutingConstants.createRouteToView(this.appController.selectedModuleID + "", ViewApplicationRoutingConstants.VIEW_APPLICATION_ROUTE, application.jobId + "")]).then();
    }
    setMapLink(application) {
        return {
            text: SharedConstants.VIEW_ON_MAP_TEXT, address: "", clickAction: () => {
                const mapLocation = {
                    moduleId: application.moduleId, applicationId: application.id, systemPrefix: application.systemPrefix
                };
                this.changeMapLocation(mapLocation);
            }
        };
    }
    changeMapLocation(mapLocation) {
        this.mapLocation.next(mapLocation);
    }
    clearURLList() {
        this.propertyUrl = "";
    }
    setURL(searchType, url) {
        switch (searchType) {
            case PropertySearchOption.Property:
            default:
                this.propertyUrl = url;
                break;
        }
    }
    findApplication(url, params, systemPrefix) {
        return this.selectedApplicationService.getSelectedApplicationGeometry(url, params).pipe(map(returnValue => {
            // @ts-ignore
            if (returnValue.value && returnValue.value.length > 0) {
                // @ts-ignore
                return this.setGeometry(systemPrefix, returnValue.value[0]);
            }
        }));
    }
    setGeometry(systemPrefix, application) {
        let searchApplicationGeometry;
        switch (systemPrefix) {
            case "CM":
                const cemeteryApplication = application;
                searchApplicationGeometry = {
                    applicationGeometry: null, systemPrefix, propertiesGeometry: []
                };
                cemeteryApplication.graves.forEach((grave) => {
                    searchApplicationGeometry.propertiesGeometry.push(grave.shape);
                });
                break;
            case "W":
                const wayleaveApplication = application;
                searchApplicationGeometry = {
                    applicationGeometry: wayleaveApplication.shape, systemPrefix, propertiesGeometry: []
                };
                if (wayleaveApplication.applicationPolygons.length > 0) {
                    wayleaveApplication.applicationPolygons.forEach((applicationPolygon) => {
                        searchApplicationGeometry.propertiesGeometry.push(applicationPolygon.shape);
                    });
                }
                if (wayleaveApplication.applicationLines.length > 0) {
                    wayleaveApplication.applicationLines.forEach((applicationLine) => {
                        searchApplicationGeometry.propertiesGeometry.push(applicationLine.shape);
                    });
                }
                break;
            case "A":
                const advertisingApplication = application;
                searchApplicationGeometry = {
                    applicationGeometry: advertisingApplication.shape, systemPrefix, propertiesGeometry: []
                };
                if (advertisingApplication.polygon) {
                    searchApplicationGeometry.propertiesGeometry.push(advertisingApplication.polygon.shape);
                }
                if (advertisingApplication.point) {
                    searchApplicationGeometry.propertiesGeometry.push(advertisingApplication.point.shape);
                }
                break;
            default:
                const selectedApplication = application;
                searchApplicationGeometry = {
                    applicationGeometry: selectedApplication.shape, systemPrefix, propertiesGeometry: []
                };
                selectedApplication.properties.forEach((property) => {
                    searchApplicationGeometry.propertiesGeometry.push(property.shape);
                });
                break;
        }
        return searchApplicationGeometry;
    }
    static ctorParameters = () => [
        { type: Router },
        { type: SelectedApplicationService },
        { type: AppControllerService }
    ];
};
SearchApplicationsService = __decorate([
    Injectable({
        providedIn: "root"
    })
], SearchApplicationsService);
export { SearchApplicationsService };
